import { Paths } from "Router/Paths";
export const MenuList = [
  {
    id: 1,
    title: "MENU",
    isPublic: true,
    list: [
      {
        title: "Home",
        path: Paths.home,
        module_slug: "home",
        icon: "home",
        view: "View Application",
        update: "Update Status"
        // add: "Add Home",
        // edit: "Edit Home"
      }
    ]
  },
  {
    id: 2,
    title: "PUC ONBOARDING",
    list: [
      {
        title: "Display Wall",
        path: Paths.displayWall,
        module_slug: "displaywall",
        icon: "display_wall",
        view: "View Application",
        // update: "Update Status"
        // add: "Add Request",
        // edit: "Edit Request"
      },
      {
        title: "All Request",
        path: Paths.allRequest,
        module_slug: "requests",
        icon: "all_request",
        view: "View Application",
        update: "Update Status"
        // add: "Add Request",
        // edit: "Edit Request"
      },
      {
        title: "Location Check",
        path: Paths.locationCheck,
        icon: "location_check",
        module_slug: "location",
        view: "View Application",
        update: "Update Status"
        // add: "Add Check",
        // edit: "Edit Check"
      },
      // {
      //   title: "Location Check Exception",
      //   path: Paths.locationCheckException,
      //   icon: "location_exception",
      //   module_slug: "exception_location_check",
      //   view: "View Application",
      //   update: "Update Status"
      //   // add: "Add Check",
      //   // edit: "Edit Check"
      // },
      {
        title: "Doc Verification",
        path: Paths.docVerification,
        icon: "doc_verification",
        view: "View Application",
        update: "Update Status",
        module_slug: "documents"
        // add: "Add Verification",
        // edit: "Edit Verification"
      },
      {
        title: "Furniture Setup",
        path: Paths.furnitureSetup,
        icon: "furniture_setup",
        view: "View Application",
        module_slug: "furniture",
        update: "Update Status",
        // add: "Add Setup",
        edit: "Update Status"
      },
      {
        title: "Deposit Check",
        path: Paths.depositcheck,
        icon: "deposit_check",
        view: "View Application",
        module_slug: "deposit",
        update: "Update Status",
        // add: "Add Check",
        edit: "Update Request"
      },
      {
        title: "Material Dispatch",
        path: Paths.materialDispatch,
        icon: "material_dispatch",
        view: "View Application",
        module_slug: "checkMaterial",
        update: "Update Status",
        // add: "Add Dispatch",
        edit: "Update Request"
      },
      {
        title: "Material Handover",
        path: Paths.materialHandover,
        icon: "material_handover",
        module_slug: "handoverMaterial",
        view: "View Application",
        update: "Update Status",
        // add: "Add Handover",
        edit: "Update Request"
      },
     
    ]
  },
  {
    id: 3,
    title: "EXCEPTIONS",
    list: [
      {
        title: "Location Check Exception",
        path: Paths.locationCheckException,
        icon: "location_exception",
        module_slug: "exception_location_check",
        view: "View Application",
        update: "Update Status"
        // add: "Add Check",
        // edit: "Edit Check"
      },
      {
        title: "Payments Exception",
        path: Paths.paymentManagementException,
        icon: "payement_mangement",
        module_slug: "exception_payment_management",
        view: "View Application",
        update: "Update Status"
        // add: "Add Check",
        // edit: "Edit Check"
      },
    ]
  },
  {
    id: 4,
    title: "ADMIN",
    list: [
      {
        title: "Manage Roles",
        path: Paths.manageRoles,
        icon: "manage_roles",
        view: "View Application",
        update: "Update Status",
        module_slug: "roles",
        add: "Add Role",
        edit: "Edit Role"
      },
      {
        title: "Manage Users",
        path: Paths.manageUsers,
        icon: "manage_users",
        view: "View Application",
        module_slug: "users",
        update: "Update Status",
        add: "Add Users",
        edit: "Edit Users"
      },
      {
        title: "Payments Management",
        path: Paths.paymentManagement,
        icon: "payement_mangement",
        view: "View Application",
        module_slug: "payment_management",
        update: "Update Status"
      }
    ]
  },
  {
    id: 5,
    title: "BANK MANAGEMENT",
    list: [
      {
        title: "Manage Banks",
        path: Paths.manageBanks,
        icon: "manage_banks",
        view: "View Application",
        update: "Update Status",
        module_slug: "banks",
        add: "Add Bank",
        edit: "Edit Bank"
      },
      {
        title: "Manage Branches",
        path: Paths.manageBranches,
        icon: "manage_branch",
        view: "View Application",
        update: "Update Status",
        module_slug: "bankBranches",
        add: "Add Branch",
        edit: "Edit Branch"
      },
      {
        title: "RCM Bank Management",
        path: Paths.rcmBankManagement,
        icon: "rcm_bank_management",
        view: "View Application",
        update: "Update Status",
        module_slug: "rcm_bank_management",
        add: "Add",
        edit: "Edit Bank"
      }
    ]
  },
  {
    id: 6,
    title: "FURNITURES & FIXTURES",
    list: [
      {
        title: "Items",
        path: Paths.furnitureItem,
        icon: "items",
        view: "View Application",
        update: "Update Status",
        module_slug: "furniture_items",
        edit: "Edit Item",
        add: "Add Item"
      },
      {
        title: "Templates",
        path: Paths.furnitureTemplate,
        icon: "templates",
        view: "View Application",
        update: "Update Status",
        module_slug: "furniture_template",
        add: "Add Template",
        edit: "Edit Template"
      }
    ]
  },

];
